// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"72":"caed75b3240d0a75","140":"ff0e50237cd5481c","239":"7434ced148ae35d6","853":"bebcf42a8cf760cb","863":"1174fac93b2c80dd"}[chunkId] + ".js";
};